export const getCurrentLang = (el?: HTMLElement): string => {
  const htmlEl = document.querySelector('html')
  const dataLang = el ? (el.dataset.lang ?? '') : ''
  const lang = dataLang || htmlEl?.getAttribute('lang') || 'en'
  return lang?.startsWith('es') ? 'es' : 'en'
}

export const createElementFromHTML = (htmlString: string): HTMLElement => {
  const div = document.createElement('div')
  div.innerHTML = htmlString.trim()
  return div.firstChild as HTMLElement
}

export const createInnerWrap = (
  el: HTMLElement,
  tag: string,
  attr: string,
  value: string
): void => {
  const wrapper = document.createElement(tag)
  wrapper.setAttribute(attr, value)
  while (el.firstChild) {
    wrapper.appendChild(el.firstChild)
  }
  el.appendChild(wrapper)
}

export const getWindowWidth = (): number => {
  return window.innerWidth || document.documentElement.clientWidth
}

export const getElCount = (els: NodeListOf<Element>): number => {
  return els ? els.length : 0
}

export default {
  getCurrentLang,
  createElementFromHTML,
  createInnerWrap,
  getWindowWidth,
  getElCount,
}
